import { Suspense, useEffect, useState } from 'react'
import 'react-animated-slider/build/horizontal.css'
import { useDispatch, useSelector } from 'react-redux'
import { BrowserRouter, Route, Routes } from 'react-router-dom'

import { CIVILISATION_LIST, FIRST_EPOCH_DATE } from '../app/constants'
import StatusPopup from '../components/ui/StatusPopup'
import { setPopUp } from '../features/popUpSlice/popUpSlice'
import { getStakeInfo } from '../features/staking/stakeInfoSlice'
import { Guard } from '../utilities/Guard'
import { Redirect } from '../utilities/Redirect'
import ViewCollection from './collections'
import ViewLeaderboard from './leaderboard'
import ViewMission from './missions'
import ViewShop from './shop'
import ViewStats from './stats'

export const App = () => {
  const user = useSelector((state) => state.user.userAccount)
  const dispatch = useDispatch()
  const popUp = useSelector((state) => state.popUp)
  const epoch = useSelector((state) => state.epoch.epoch)

  useEffect(() => {
    if (user) {
      dispatch(getStakeInfo())
    }
  }, [user, dispatch, epoch])

  const Loader = () => <div>Loading...</div>
  console.log(user)
  if (!user) {
    return (
      <Suspense fallback={<Loader />}>
        <BrowserRouter>
          <Guard />
        </BrowserRouter>
      </Suspense>
    )
  }

  return (
    <Suspense fallback={<Loader />}>
      <BrowserRouter>
        <Routes>
          <Route path="*" element={<Redirect />} />
          {/* Collections  */}
          <Route
            exact
            path="/collection"
            element={<ViewCollection civilisation="Alliance" />}
          />
          <Route exact path="/shop" element={<ViewShop />} />
          {/* This could be improved, rendering a different element at the moment as the slider doesn't support rerendering on prop change for some reason - have left a ticket on the github repo */}
          {CIVILISATION_LIST.map((civilisation, i) => (
            <Route
              key={`/collection/${civilisation}`}
              path={`/collection/${civilisation}`}
              element={<ViewCollection civilisation={civilisation} />}
            />
          ))}
          {/* Missions */}
          <Route exact path="/missions" element={<Mission />}></Route>
          {CIVILISATION_LIST.map((civilisation, i) => (
            <Route
              key={`/missions/${civilisation}`}
              path={`/missions/${civilisation}`}
              element={<Mission civilisation={civilisation} />}
            />
          ))}
          <Route exact path="/my-stats" element={<ViewStats />} />
          {CIVILISATION_LIST.map((civilisation, i) => (
            <Route
              key={`/my-stats/${civilisation}`}
              path={`/my-stats/${civilisation}`}
              element={<ViewStats civilisation={civilisation} />}
            />
          ))}
          <Route exact path="/leaderboard" element={<ViewLeaderboard />} />
          {CIVILISATION_LIST.map((civilisation, i) => (
            <Route
              key={`/leaderboard/${civilisation}`}
              path={`/leaderboard/${civilisation}`}
              element={<ViewLeaderboard civilisation={civilisation} />}
            />
          ))}
        </Routes>
      </BrowserRouter>
      <StatusPopup
        isOpen={popUp.isOpen}
        status={popUp.status}
        setIsOpen={(set) => dispatch(setPopUp({ isOpen: set }))}
      />
    </Suspense>
  )
}

const Mission = ({ civilisation }) => {
  const today = new Date();
  const releaseDate = FIRST_EPOCH_DATE
  const Epoch = (today - releaseDate) / (1000 * 60 * 60 * 2);
  const epochType = Math.floor(Epoch) % 3;
  const [remainingTime, setRemainingTime] = useState('--:--')

  const dayTime = 1000 * 60 * 60 * 2
  let now = new Date()
  let EpochTime = (now - new Date('2023-03-15T00:00:00')) / dayTime

  function getRemainingTime() {
    now = new Date()
    EpochTime = (now - new Date('2023-03-15T00:00:00')) / dayTime
    const remainingHours = Math.floor(
      (1 - (EpochTime - Math.floor(EpochTime))) * 2,
    )
    const remainingMinutes = Math.floor(
      ((1 - (EpochTime - Math.floor(EpochTime))) * 2 - remainingHours) * 60,
    )
    if (remainingMinutes < 10) {
      setRemainingTime(`${remainingHours}:0${remainingMinutes}`)
    } else {
      setRemainingTime(`${remainingHours}:${remainingMinutes}`)
    }
  }

  useEffect(() => {
    const timer = setInterval(() => {
      getRemainingTime()
    }, 1000)

    return () => clearInterval(timer)
  })

  // Change epochDay manually below to change Mission Epoch - Replace with Epoch Type variable for "real" Epoch Day Type
  const epochDay = Math.floor(EpochTime % 3) + 1
  switch (epochDay) {
    case 1:
      return (
        <ViewMission
          civilisation={civilisation ?? 'Alliance'}
          component="missionDayOne"
          pageTitle="Epoch Day One"
          remainingTime={remainingTime}
        />
      )
    case 2:
      return (
        <ViewMission
          civilisation={civilisation ?? 'Alliance'}
          component="missionDayTwo"
          pageTitle="Epoch Day Two"
          vertical={true}
          remainingTime={remainingTime}
        />
      )
    case 3:
      return (
        <ViewMission
          civilisation={civilisation ?? 'Alliance'}
          component="missionDayThree"
          pageTitle="Epoch Day Three"
          vertical={true}
          remainingTime={remainingTime}
        />
      )
    default:
      break
  }
}

export default App
